import { Loader2 } from "lucide-react";

export function Spinner({ size = 20, className = "" }) {
  return (
    <Loader2
      className={`animate-spin text-[color:var(--brand)] ${className}`}
      style={{ width: size, height: size }}
      data-testid="loading-spinner"
    />
  );
}

export function PageSpinner({ label }) {
  return (
    <div
      className="min-h-screen grid place-items-center bg-app"
      data-testid="page-loading"
    >
      <div className="flex flex-col items-center gap-3">
        <Spinner size={36} />
        {label ? <div className="text-ink-2 text-sm">{label}</div> : null}
      </div>
    </div>
  );
}

export function InlineSpinner({ label }) {
  return (
    <div className="flex items-center justify-center gap-2 py-6" data-testid="inline-loading">
      <Spinner size={22} />
      {label ? <div className="text-ink-2 text-sm">{label}</div> : null}
    </div>
  );
}
